import type { Translations } from './types';

const hi: Translations = {
    next: 'अगला',
    storyReadPrompt: 'कृपया पहले कहानी पढ़ें।',
    backToStory: '← कहानी पर वापस जाएं',
    nextArrow: 'अगला →',
    finishAssessment: 'मूल्यांकन समाप्त करें →',
    common_step: 'चरण',
    questionsStory1: 'प्रश्न — कहानी 1',
    questionsStory2: 'प्रश्न — कहानी 2',
    lastSetOfQuestions: 'अंतिम प्रश्न — लगभग हो गया! 🎉',
    typeAnswerHere: 'यहाँ अपना उत्तर लिखें...',
    backCountSingular: '📖 आप {n} बार कहानी दोबारा पढ़ने के लिए इस पृष्ठ पर वापस आए।',
    backCountPlural: '📖 आप {n} बार कहानी दोबारा पढ़ने के लिए इस पृष्ठ पर वापस आए।',

    assessmentComplete: 'मूल्यांकन पूर्ण! 🎉',
    assessmentSubtitle: 'आपने सीखने की अक्षमताओं को समझने की दिशा में एक महत्वपूर्ण कदम उठाया है',
    returnToHome: 'घर वापस जाएं',
    assessmentSuccessfullyCompleted: 'मूल्यांकन सफलतापूर्वक पूर्ण',
    amazingJob: 'शानदार काम!',
    youCrushedIt: 'आपने इसे कर दिखाया! यहाँ आपकी उपलब्धियाँ हैं:',
    whatsNext: 'आगे क्या?',
    getReadyForResults: 'अपने व्यक्तिगत परिणामों के लिए तैयार हो जाएं',
    youDidIt: 'आपने कर दिखाया!',
    youDidItDesc:
      'सीखने की अक्षमताओं को समझने के प्रति आपकी प्रतिबद्धता वास्तव में प्रेरणादायक है। जहाँ दूसरे छोड़ देते, आपने इसे अंत तक पूरा किया!',

    heroLine1: 'डिस्लेक्सिया',
    heroLine2: 'जांच',
    heroTagline: 'एक ही बैठक में',
    heroSubtitle:
      'ब्राउज़र में होने वाला मल्टी-मोडल आकलन, जो टेस्ट खत्म होते ही लिखित रिपोर्ट देता है — न क्लिनिक जाना, न प्रतीक्षा सूची, न कोई विशेष उपकरण।',
    heroBetaLabel: 'बीटा',
    startAssessment: 'शुरू करें',
    trustedBy: 'दुनिया भर के शिक्षकों और शोधकर्ताओं द्वारा विश्वसनीय',

    pfp_privacyBadge: 'गोपनीयता और अनुपालन',
    pfp_privacyHeading: 'हम पूर्ण GDPR और MDR अनुपालन के साथ डेटा सुरक्षा को गंभीरता से लेते हैं',
    pfp_formBadge: 'मूल्यांकन शुरू करें',
    pfp_ctaHeading: 'डिस्लेक्सिया जांच',
    pfp_ctaDesc: 'हमारे AI-संचालित मूल्यांकन के माध्यम से अपनी पढ़ने की शैली के बारे में अद्वितीय अंतर्दृष्टि खोजने वाले हजारों लोगों में शामिल हों।',
    pfp_ctaFooter: 'कोई समय सीमा नहीं • अपनी गति से • 100% गोपनीय',
    pfp_whyTitle: 'DysTest क्यों?',
    pfp_whySubtitle: 'जानें कि हमारा AI-संचालित मूल्यांकन सबसे सटीक और विश्वसनीय समाधान क्यों है',
    pfp_whyDesc: 'DysTest डिस्लेक्सिया अनुसंधान में 20 से अधिक वर्षों की पेशेवर विशेषज्ञता को जीवन भर के अनुभव के साथ जोड़ता है। डिस्लेक्सिक और न्यूरोटिपिकल पाठकों के पाठ संसाधन को समझकर, हमारा AI उन सूक्ष्म पढ़ने के पैटर्न को पहचानता है जो पारंपरिक परीक्षण चूक जाते हैं।',
    pfp_feature1Title: 'नेत्र-ट्रैकिंग, की-बोर्ड विश्लेषण और बहुभाषी अंतर्दृष्टि',
    pfp_feature1Desc: 'उन्नत AI नेत्र गतिविधियों, चेहरे के संकेतों और टाइपिंग का विश्लेषण करता है — किसी भी भाषा में। DysTest बहुभाषी उपयोगकर्ताओं के लिए सटीक, व्यक्तिगत समझ प्रदान करने के लिए बुद्धिमानी से अनुकूलित होता है।',
    pfp_feature2Title: 'तत्काल, कार्रवाई योग्य परिणाम',
    pfp_feature2Desc: 'कुछ ही मिनटों में स्पष्ट, विज्ञान-आधारित अंतर्दृष्टि प्राप्त करें। हमारी रिपोर्टें जटिल डेटा को आसानी से समझने योग्य सिफारिशों में अनुवाद करती हैं।',
    pfp_feature3Title: 'पहले गोपनीयता और अनुपालन',
    pfp_feature3Desc: 'आपका डेटा एन्क्रिप्टेड, गुमनाम और उच्चतम नैतिक मानकों के तहत संभाला जाता है — पूरी तरह GDPR और MDR के अनुरूप।',
    pfp_feature4Title: 'सुलभ, मानव-केंद्रित डिज़ाइन',
    pfp_feature4Desc: 'DysTest आपको अपनी गति से स्क्रीन करने देता है — शांत, सहज और दबाव-मुक्त। यह फिर से परिभाषित करता है कि सीखने की अक्षमताएं कैसे खोजी और समर्थित की जाती हैं।',
    pfp_finalCtaDesc: 'आज ही अपनी व्यक्तिगत AI-संचालित डिस्लेक्सिया जांच शुरू करें — यह समझने के लिए डिज़ाइन किया गया है कि आप कैसे पढ़ते हैं, न कि केवल क्या पढ़ते हैं।',

    hiw_badge: 'सरल 8-चरण प्रक्रिया',
    hiw_heading: 'मूल्यांकन कैसे काम करता है',
    hiw_subtext: 'पंजीकरण से लेकर विस्तृत डिस्लेक्सिया मूल्यांकन रिपोर्ट तक — पूरी तरह ब्राउज़र में, कोई डाउनलोड आवश्यक नहीं।',
    hiw_step1Title: 'पंजीकरण',
    hiw_step1Desc: 'अपना नाम, आयु और पसंदीदा भाषा दर्ज करें। कोई खाता आवश्यक नहीं — 2 मिनट से कम समय लगता है।',
    hiw_step2Title: 'नेत्र अंशांकन',
    hiw_step2Desc: '16 एनिमेटेड बिंदुओं का अनुसरण करें। AI आईरिस ट्रैकर आपकी अनूठी दृष्टि पहचान सीखता है।',
    hiw_step3Title: 'शब्द और चित्र',
    hiw_step3Desc: 'शब्दों को उनके चित्रों से मिलाएं, जबकि हम पहचान गति और दृश्य-ध्वन्यात्मक प्रसंस्करण मापते हैं।',
    hiw_step4Title: 'RAN गति परीक्षण',
    hiw_step4Desc: 'जितनी जल्दी हो सके रंगों या वस्तुओं की एक श्रृंखला को ज़ोर से नाम दें। पुनर्प्राप्ति प्रवाह को मापता है।',
    hiw_step5Title: 'कहानियाँ और प्रश्न',
    hiw_step5Desc: 'दो आयु-उपयुक्त कहानियाँ पढ़ें और समझ के प्रश्नों का उत्तर दें। नेत्र गतिविधि और पलकें रिकॉर्ड की जाती हैं।',
    hiw_step6Title: 'शब्द लेखन',
    hiw_step6Desc: 'याददाश्त से शब्द टाइप करें। कीस्ट्रोक समय और त्रुटि पैटर्न वर्तनी और मोटर प्रसंस्करण प्रकट करते हैं।',
    hiw_step7Title: 'प्रतिक्रिया',
    hiw_step7Desc: 'अपना अनुभव और चिंताएं साझा करें। यह संदर्भ नैदानिक व्याख्या को कैलिब्रेट करने में मदद करता है।',
    hiw_step8Title: 'परिणाम प्राप्त करें',
    hiw_step8Desc: 'डिस्लेक्सिया जोखिम संकेतकों, दृष्टि हीटमैप और पठन मेट्रिक्स के साथ विस्तृत रिपोर्ट प्राप्त करें।',

    pf_whoTaking: 'टेस्ट कौन दे रहा है?',
    pf_myself: 'मैं स्वयं',
    pf_myselfAge: 'आयु 13+',
    pf_child: 'बच्चा',
    pf_childAgeRange: 'आयु 5-12',
    pf_verifyEmailTitle: 'अपना ईमेल सत्यापित करें',
    pf_parentalConsentStepTitle: 'माता-पिता की सहमति',
    pf_verifyEmailDesc: 'पंजीकरण पूरा करने के लिए अपने ईमेल पर भेजा गया कोड दर्ज करें',
    pf_consentDesc: 'कृपया डेटा प्रसंस्करण के लिए सहमति की समीक्षा करें और प्रदान करें',
    pf_yourName: 'प्रतिभागी का नाम *',
    pf_yourNamePlaceholder: 'अपना पूरा नाम दर्ज करें',
    pf_emailAddress: 'ईमेल पता *',
    pf_assessmentLanguage: 'मूल्यांकन की भाषा',
    pf_emailPlaceholder: 'अपना ईमेल दर्ज करें',
    pf_invalidEmail: 'कृपया एक वैध ईमेल पता दर्ज करें',
    pf_yourAge: 'आपकी आयु *',
    pf_selectAge: 'अपनी आयु चुनें',
    pf_yearsUnit: 'वर्ष',
    pf_dyslexiaTested: 'क्या आपका डिस्लेक्सिया परीक्षण हुआ है? *',
    pf_iAmDyslexic: 'हां, आधिकारिक रूप से निदान हुआ है',
    pf_iAmNotDyslexic: 'परीक्षण हुआ और डिस्लेक्सिया नहीं है',
    pf_notKnown: 'पता नहीं',
    pf_parentName: 'माता-पिता का नाम *',
    pf_parentNamePlaceholder: 'माता-पिता का नाम दर्ज करें',
    pf_childName: 'बच्चे का नाम *',
    pf_childNamePlaceholder: 'बच्चे का नाम दर्ज करें',
    pf_childAgeLabel: 'बच्चे की आयु *',
    pf_selectChildAge: 'बच्चे की आयु चुनें',
    pf_childDyslexiaTested: 'क्या आपके बच्चे का डिस्लेक्सिया परीक्षण हुआ है? *',
    pf_yesHasDyslexia: 'हां, आधिकारिक रूप से निदान हुआ है',
    pf_yesNoDyslexia: 'परीक्षण हुआ और डिस्लेक्सिया नहीं है',
    pf_noNotTested: 'नहीं, कभी परीक्षण नहीं हुआ',
    pf_nativeLangQuestion: 'आप घर पर कौन सी भाषा बोलते हैं?',
    pf_browserLangDetected: 'ब्राउज़र भाषा पहचानी गई:',
    pf_availableInSystem: '✓ हमारे सिस्टम में उपलब्ध',
    pf_yesNative: 'हां, यह मेरी मातृभाषा है',
    pf_othersNative: 'अन्य, मैं दूसरी भाषाएं अधिक उपयोग करता/करती हूं',
    pf_specifyNative: 'कृपया अपनी मातृभाषा बताएं *',
    pf_selectNativePlaceholder: 'अपनी मातृभाषा चुनें',
    pf_selectNativeError: 'कृपया अपनी मातृभाषा चुनें',
    pf_nativeLangNote: 'यह हमें आपकी भाषाई पृष्ठभूमि के आधार पर अधिक सटीक मूल्यांकन परिणाम प्रदान करने में मदद करता है। आपकी ब्राउज़र भाषा ({lang}) स्वचालित रूप से पहचानी गई — हम भाषा पहचान के लिए आपके IP पते का उपयोग कभी नहीं करते।',
    pf_forYourChild: 'आपके बच्चे के लिए',
    pf_childExplanation: 'कंप्यूटर देखता है कि आप कैसे पढ़ते हैं — आपका चेहरा, आंखें और टाइपिंग — आपकी पढ़ने की शैली समझने के लिए। आपके डेटा के साथ कुछ बुरा नहीं होता। आपके माता-पिता ने कहा है कि यह ठीक है, और आप जब चाहें रुक सकते हैं।',
    pf_parentalConsentLabel: 'माता-पिता की सहमति *',
    pf_parentalConsentText: 'मैं GDPR और MDR के अनुपालन में डिस्लेक्सिया जांच और शिक्षा मूल्यांकन के लिए अपने बच्चे के (या मेरे स्वयं के) चेहरे, नेत्र-गति और कीबोर्ड इंटरैक्शन डेटा के प्रसंस्करण के लिए सहमति देता/देती हूं।',
    pf_dataConsentLabel: 'डेटा प्रसंस्करण सहमति और गोपनीयता नीति *',
    pf_dataConsentText: 'मैं स्क्रीनिंग उद्देश्यों के लिए अपने व्यक्तिगत डेटा के प्रसंस्करण से सहमत हूं।\nमैंने गोपनीयता नीति और सेवा की शर्तें पढ़ी हैं और उनसे सहमत हूं।',
    pf_consentPre: 'मैं',
    pf_consentPrivacyLink: 'गोपनीयता नीति',
    pf_consentBetween: 'और',
    pf_consentTermsLink: 'सेवा की शर्तें',
    pf_consentPost: 'से सहमत हूं, जिसमें स्क्रीनिंग उद्देश्यों के लिए डेटा प्रसंस्करण शामिल है।',
    pf_emailFailedTitle: 'ईमेल भेजने में विफल',
    pf_checkYourEmail: 'अपना ईमेल जांचें',
    pf_emailSentDesc: 'हमने {email} पर एक 6-अंकीय सत्यापन कोड भेजा है। कृपया अपना इनबॉक्स जांचें और नीचे कोड दर्ज करें।',
    pf_emailFailedDesc: '{email} पर भेजने में विफल।',
    pf_tryAgain: 'पुनः प्रयास करें',
    pf_sendingEmail: 'भेजा जा रहा है...',
    pf_verificationCodeLabel: 'सत्यापन कोड *',
    pf_enterCodePlaceholder: '6-अंकीय कोड दर्ज करें',
    pf_codeExpiry: 'अपने ईमेल से 6-अंकीय कोड दर्ज करें। कोड 15 मिनट में समाप्त हो जाता है।',
    pf_resendCode: 'कोड नहीं मिला? पुनः भेजने के लिए क्लिक करें',
    pf_sendingNewCode: 'नया कोड भेजा जा रहा है...',
    pf_continue: 'जारी रखें',
    pf_continueToConsent: 'सहमति पर जारी रखें',
    pf_verifyEmailBtn: 'ईमेल सत्यापित करें',
    pf_verifying: 'सत्यापित किया जा रहा है...',
    pf_processing: 'प्रसंस्करण...',
    pf_importantNotice: 'महत्वपूर्ण सूचना',
    pf_disclaimer: 'DysTest एक डिजिटल स्क्रीनिंग उपकरण है जो प्रारंभिक पहचान और शिक्षण अंतर्दृष्टि का समर्थन करने के लिए डिज़ाइन किया गया है। यह चिकित्सा निदान नहीं देता। आधिकारिक निदान या नैदानिक सलाह के लिए कृपया योग्य स्वास्थ्य पेशेवरों से परामर्श करें।',
            cg_readingAssessment: 'पढ़ने का मूल्यांकन',
    cg_whatsNext: 'आगे क्या है',
    cg_twoSections: 'दो छोटे खंड — एक कहानी पढ़ें, फिर कुछ सवालों के जवाब दें',
    cg_readStory: 'कहानी पढ़ें',
    cg_readStoryDesc: 'समय लें — अपनी गति से पढ़ें',
    cg_answerQuestions: 'कुछ सवालों के जवाब दें',
    cg_answerQuestionsDesc: 'अपने शब्दों में जवाब लिखें — कोई सही या गलत नहीं',
    cg_exampleQuestion: 'कहानी की शुरुआत में क्या हुआ?',
    cg_exampleAnswer: 'लड़का पार्क में गया…',
    cg_startReading: 'पढ़ना शुरू करें',
    cg_warmupGame: 'वार्म-अप खेल',
    cg_matchHeading: 'शब्द को चित्र से मिलाएं',
    cg_matchSubtitle: 'एक शब्द कार्ड पर क्लिक करें, फिर जोड़ी पूरी करने के लिए मिलान चित्र पर क्लिक करें',
    cg_startMatching: 'मिलान शुरू करें!',
    cg_demoWord: 'बिल्ली',
    cg_allMatched: 'सभी जोड़े मिल गए!',
    cg_heatmapContinuing: 'आपका दृष्टि हीटमैप नीचे दिखाया गया है — जल्द ही जारी रहेगा…',
    cg_lookAtTarget: '👁️ लक्ष्य देख रहे हैं!',
    cg_lookAtDot: 'लाल बिंदु को देखें',
    cg_sRemaining: 'सेकंड शेष',
    cg_skipFixation: 'फिक्सेशन छोड़ें',
    cg_correct: '✓ सही!',
    cg_tryAgain: '✗ फिर से प्रयास करें',
    cg_liveMetrics: 'लाइव मेट्रिक्स',
    cg_blinks: 'पलकें',
    cg_matched: 'मिले',
    cg_errors: 'त्रुटियाँ',
    fpc_instruction: 'हर बिंदु को देखें',
    fpc_dotsTotal: 'बिंदु कुल — हर बिंदु को सीधे देखें और अपनी नज़र रखें। यह स्वचालित रूप से कैप्चर होता है।',
    fpc_cancelCalibration: 'कैलिब्रेशन रद्द करें',
    fpc_clickMe: 'मुझे क्लिक करें!',
    fpc_eyeTrackingStarting: 'आँख ट्रैकिंग शुरू हो रही है — आप अभी क्लिक कर सकते हैं!',
    fpc_calibrationComplete: 'कैलिब्रेशन पूर्ण!',
    fpc_trainingSamples: '{n} प्रशिक्षण नमूने रिकॉर्ड किए गए',
    fpc_allPointsDone: 'सभी बिंदु पूर्ण!',
    fpc_pointOf: 'बिंदु {current} में से {total}',
    fpc_training: 'प्रशिक्षण',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'कैलिब्रेशन सहेजा जा रहा है…',
    fpc_moveEyes: 'अपनी आँखें बिंदु की ओर ले जाएँ…',
    fpc_noFace: '⚠️ कोई चेहरा नहीं मिला — कैमरे के सामने अपना चेहरा केंद्रित करें',
    fpc_missingIrisTitle: '⚠️ बहुत अधिक बिंदुओं पर आइरिस डेटा अनुपलब्ध था',
    fpc_missingIrisBody: 'कई अंशांकन बिंदु छोड़ दिए गए क्योंकि आइरिस लैंडमार्क का पता नहीं चला।',
    fpc_lowAccuracyTitle: 'सटीकता अपेक्षा से कम',
    fpc_lowAccuracyBody: 'अंशांकन त्रुटि आदर्श से अधिक है। इससे नेत्र ट्रैकिंग सटीकता कम हो सकती है।',
    fpc_redoCalibration: 'अंशांकन दोहराएं',
    fpc_continueAnyway: 'फिर भी जारी रखें',
    fpc_lookAtDot: 'बिंदु को सीधे देखें',
    fpc_dotReady: '✓ बिंदु कैप्चर किया — आगे बढ़ रहे हैं…',
    fpc_keepLooking: 'बिंदु को देखते रहें — यह स्वचालित रूप से कैप्चर होता है',
    fpc_captured: '✓ कैप्चर हुआ! अगले की ओर…',
    fpc_checkingAccuracy: 'सटीकता जाँच रहे हैं',
    fpc_valGotIt: 'हो गया! अगले की ओर…',
    fpc_valHoldStill: 'स्थिर रहें — डेटा एकत्र हो रहा है…',
    fpc_valLookDot: 'बिंदु को देखें — तैयार होने पर यह नारंगी हो जाएगा',
    fpc_valCheck: 'जाँच',

    acp_welcome: 'स्वागत है, {name}!',
    acp_setupSubtitle: 'आइए आपका मूल्यांकन सेट करें',
    acp_setupVerification: 'सेटअप सत्यापन',
    acp_setupStepsDesc: 'मूल्यांकन अनलॉक करने के लिए सभी चरण पूरे करें',
    acp_step1Title: 'कैमरा सक्रिय',
    acp_step1Desc: 'कैमरा स्वचालित रूप से शुरू होता है — कोई कार्रवाई आवश्यक नहीं',
    acp_step2Title: 'कैमरा सत्यापन',
    acp_step2Desc: 'कैमरा गुणवत्ता और स्थिरता सत्यापित करें',
    acp_step3Title: 'टाइपिंग परीक्षण',
    acp_step3Desc: 'कीबोर्ड कार्यक्षमता सत्यापित करें',
    acp_step4Title: 'नेत्र अंशांकन',
    acp_step4Desc: 'नेत्र ट्रैकिंग सिस्टम कैलिब्रेट करें',
    acp_eyeTrackingActive: '✓ नेत्र ट्रैकिंग सक्रिय',
    acp_eyeTrackingError: '⚠ नेत्र ट्रैकिंग त्रुटि:',
    acp_startingEyeTracking: '⏳ नेत्र ट्रैकिंग शुरू हो रही है...',
    acp_cameraReady: '👁 कैमरा तैयार',
    acp_waitingForCamera: '📷 कैमरा स्वचालित रूप से शुरू हो रहा है...',
    acp_stepDone: 'पूर्ण',
    acp_stepInProgress: 'जारी है',
    acp_checkingCameraStability: 'कैमरा स्थिरता जांची जा रही है...',
    acp_cameraVerified: 'कैमरा सत्यापित ✓',
    acp_autoVerifyingCamera: 'कैमरा स्वचालित सत्यापन...',
    acp_waitingFaceDetection: 'चेहरा पहचान की प्रतीक्षा...',
    acp_eyeTrackingStarting: 'नेत्र ट्रैकिंग शुरू हो रही है...',
    acp_calibrationInProgress: 'अंशांकन जारी है...',
    acp_eyeTrackingReady: 'नेत्र ट्रैकिंग तैयार ✓',
    acp_startingCalibration: 'अंशांकन शुरू हो रहा है...',
    acp_distanceHint: 'अपना चेहरा बीच में और स्थिर रखें, स्क्रीन से 60 सेमी से ज़्यादा दूर नहीं',
    acp_distanceLabel: 'अधिकतम 60 सेमी',
    acp_fpsTitle: 'आपका कैमरा थोड़ा धीमा है',
    acp_fpsBody: 'यह हर सेकंड {fps} चित्र देता है; नज़र की माप के लिए कम से कम 10 चित्र चाहिए। ये उपाय आमतौर पर कुछ ही सेकंड में मदद करते हैं:',
    acp_fpsVeryLow: 'इस गति पर आँखों की गतिविधि के कुछ माप शायद उपयोगी न हों; बाकी कार्य फिर भी गिने जाते हैं।',
    acp_fpsTipLight: 'ज़्यादा रोशनी करें या खिड़की की ओर मुँह करके बैठें',
    acp_fpsTipCharger: 'चार्जर लगाएँ (बैटरी बचत लैपटॉप को धीमा कर देती है)',
    acp_fpsTipApps: 'वीडियो कॉल और दूसरे भारी प्रोग्राम बंद करें',
    acp_fpsCheckAgain: 'फिर से जाँचें',
    acp_fpsChecking: 'जाँच हो रही है…',
    acp_fpsContinue: 'फिर भी आगे बढ़ें',
    acp_preparingEyeTracking: 'नेत्र ट्रैकिंग तैयार की जा रही है...',
    acp_cameraPreview: 'कैमरा पूर्वावलोकन',
    acp_noFaceDetected: 'कोई चेहरा नहीं पहचाना',
    acp_live: 'लाइव',
    acp_cameraVerifiedTitle: 'कैमरा सत्यापित ✓',
    acp_cameraReadyTitle: 'कैमरा तैयार',
    acp_qualityCheckPassed: 'गुणवत्ता जांच पास',
    acp_optimizedForAssessment: 'मूल्यांकन के लिए अनुकूलित',
    acp_verifiedBadge: 'सत्यापित',
    acp_readyBadge: 'तैयार',
    acp_assessmentMetrics: 'मूल्यांकन मेट्रिक्स',
    acp_faceDistance: 'चेहरे की दूरी',
    acp_goodDistance: 'मूल्यांकन के लिए अच्छी दूरी',
    acp_searching: 'खोज रहे हैं...',
    acp_lightLevel: 'प्रकाश स्तर',
    acp_fps: 'FPS',
    acp_fpsExcellent: 'उत्कृष्ट फ्रेम दर',
    acp_fpsGood: 'अच्छी फ्रेम दर',
    acp_fpsModerate: 'मध्यम फ्रेम दर',
    acp_fpsLow: 'कम फ्रेम दर',
    acp_fpsInitializing: 'प्रारंभ हो रहा है...',
    acp_faceDetection: 'चेहरा पहचान',
    acp_faceDetected: '✓ पहचाना गया',
    acp_faceDetectedSub: 'चेहरा सफलतापूर्वक पहचाना गया',
    acp_cameraQualityPassed: 'कैमरा गुणवत्ता जांच पास। अगले चरण के लिए तैयार।',
    acp_visionWarnings: 'दृष्टि चेतावनियां',
    acp_trackingMetrics: 'ट्रैकिंग मेट्रिक्स',
    acp_headPitch: 'सिर झुकाव:',
    acp_headYaw: 'सिर घुमाव:',
    acp_headRoll: 'सिर रोल:',
    acp_gazePoint: 'दृष्टि बिंदु:',
    acp_emotion: 'भावना:',
    acp_confidence: 'विश्वास:',
    acp_trackingId: 'ट्रैकिंग ID:',
    acp_faceId: 'चेहरा ID:',
    acp_browser: 'ब्राउज़र:',
    acp_os: 'OS:',
    acp_camera: 'कैमरा:',
    acp_resolution: 'रिज़ॉल्यूशन:',
    acp_initializingTracking: 'ट्रैकिंग मेट्रिक्स प्रारंभ हो रहे हैं...',
    acp_dataQuality: 'डेटा गुणवत्ता',
    acp_dataQualityExcellent: 'उत्कृष्ट',
    acp_dataQualityGood: 'अच्छा',
    acp_dataQualityFair: 'स्वीकार्य',
    acp_dataQualityDetecting: 'पहचान...',
    acp_dataQualityExcellentDesc: 'मूल्यांकन के लिए इष्टतम',
    acp_dataQualityGoodDesc: 'मूल्यांकन के लिए अच्छा',
    acp_dataQualityFairDesc: 'स्वीकार्य गुणवत्ता',
    acp_dataQualityDetectingDesc: 'स्थितियों का विश्लेषण',
    acp_faceMeshPoints: 'चेहरा मेश बिंदु',
    acp_completeFaceMesh: 'पूर्ण चेहरा मेश',
    acp_detecting: 'पहचान रहे हैं...',
    acp_typingTest: 'टाइपिंग परीक्षण',
    acp_typeQwerty: 'कीबोर्ड सत्यापित करने के लिए {target} टाइप करें',
    acp_verifyKeyboard: 'कीबोर्ड कार्यक्षमता सत्यापित करें',
    acp_activeStatus: 'सक्रिय',
    acp_lockedStatus: 'लॉक',
    acp_typeHere: 'यहां टाइप करें...',
    acp_typingCompleted: '✓ पूर्ण! अगले चरण पर जा रहे हैं...',
    acp_keepTyping: 'टाइप जारी रखें:',
    acp_remaining: 'शेष',
    acp_startTyping: 'ऊपर के अक्षर टाइप करना शुरू करें',
    acp_completeCameraVerification: 'अनलॉक करने के लिए कैमरा सत्यापन पूरा करें',
    acp_lightingPerfect: 'मूल्यांकन के लिए सही प्रकाश',
    acp_lightingSlightlyBright: 'थोड़ा ज्यादा उजाला — संभव हो तो कम करें',
    acp_lightingTooBright: 'बहुत ज्यादा उजाला — प्रकाश/स्क्रीन चमक कम करें',
    acp_lightingSlightlyDim: 'थोड़ा कम उजाला — संभव हो तो बढ़ाएं',
    acp_lightingTooDim: 'बहुत कम उजाला — प्रकाश बढ़ाएं',
    acp_positionFace: '👤 अपना चेहरा कैमरे के सामने रखें',
    acp_faceDetectedStarting: '✅ चेहरा पहचाना गया — सत्यापन शुरू हो रहा है...',
    acp_adjustDistance: 'कैमरे से अपनी दूरी समायोजित करें',
    acp_moveFarther: 'कैमरे से दूर हटें',
    acp_distanceInRange: 'दूरी ठीक लग रही है',
    pdg_moveCloser: 'कैमरे के करीब आएं',
    pdg_moveFarther: 'कैमरे से दूर हटें',
    pdg_dismiss: 'खारिज करें',
    acp_noData: 'कोई डेटा नहीं',
    acp_setupProgress: 'सेटअप प्रगति',
    acp_stepsComplete: '4 में से {n} चरण पूर्ण',
    acp_environment: 'वातावरण',
    acp_checkingEllipsis: 'जाँच हो रही है…',
    acp_waitingEllipsis: 'प्रतीक्षा…',
    acp_analysingConditions: 'कैमरा स्थितियों का विश्लेषण…',
    acp_positionFaceCamera: 'अपना चेहरा कैमरे के सामने रखें',
    acp_faceAligned: 'चेहरा संरेखित',
    shared_stepOf: 'चरण {step} में से {total}',
    shared_start: 'शुरू करें',
    cal_introHeading: 'अंशांकन',
    cal_introSubtitle: 'बिंदुओं को देखें और सिर स्थिर रखें',
    story_introHeading: 'पढ़ना और प्रश्न',
    fpc_lookHere: '👆 आगे बढ़ने के लिए बिंदु पर क्लिक करें',
            pfp_chip_gdpr: 'GDPR अनुपालन',
    pfp_chip_mdr: 'MDR संरेखित',
    pfp_chip_noData: 'डेटा साझाकरण नहीं',
    pfp_chip_languages: '8 भाषाएं',
    kbv_header: 'कीबोर्ड डायनेमिक्स',
    kbv_interKey: 'कुंजी-अंतराल',
    kbv_typingSpeed: 'टाइपिंग गति',
        pfp_aiBadge: 'आई-ट्रैकिंग डिस्लेक्सिया स्क्रीनिंग टूल',
    pfp_whyBadge: 'DysTest क्यों',
    mat_missionBadge: 'हमारा मिशन और तकनीक',
    mat_eyeBadge: 'आँख ट्रैकिंग',
    mat_kbdBadge: 'कीस्ट्रोक विश्लेषण',
    mat_ferBadge: 'चेहरे की अभिव्यक्ति',
    pfp_noBrowserFooter: 'खाता आवश्यक नहीं · पूरी तरह ब्राउज़र में · परिणाम <15 मिनट में',
    eye_viz_landmarks: '478 बिंदु',
    eye_viz_irisFaceMesh: 'आईरिस + चेहरा जाल',
    eye_viz_fps: '30 FPS रियल-टाइम',
    eye_viz_validation: '9-बिंदु + 4-बिंदु सत्यापन',
    eye_viz_calibration: 'नैदानिक 13-बिंदु कैलिब्रेशन',
    ran_anim_rapidNaming: 'तीव्र नामकरण',
    ran_anim_predictor: '#1 डिस्लेक्सिया संकेतक',
    ran_anim_ageNormed: 'आयु-मानक स्कोरिंग',
    ran_anim_zscore: 'z-स्कोर + पर्सेंटाइल',
    acp_hideDetails: 'विवरण छुपाएं ▲',
    acp_showDetails: 'विवरण दिखाएं ▼',
    acp_moveCloser: 'करीब आएं',
    acp_headLabel: 'सिर',
    acp_setupTipsTitle: 'त्वरित सेटअप सुझाव',
    acp_tip1: 'स्क्रीन से ~50 सेमी की दूरी पर बैठें',
    acp_tip2: 'अपने चेहरे पर समान, तेज रोशनी सुनिश्चित करें',
    acp_tip3: 'सिर सीधा रखें और सीधे कैमरे में देखें',
    acp_tip4: 'बेहतर मूल्यांकन के लिए शांत वातावरण का उपयोग करें',
    acp_progressLabel: 'प्रगति',

    priv_gdprTitle: 'GDPR अनुरूप',
    priv_gdpr1: '13 वर्ष से कम उम्र के उपयोगकर्ताओं के लिए सत्यापन योग्य माता-पिता की सहमति',
    priv_gdpr2: 'डेटा न्यूनतमीकरण और उद्देश्य सीमा',
    priv_gdpr3: 'डेटा तक पहुंचने, सुधारने और हटाने का अधिकार',
    priv_gdpr4: 'पारदर्शी डेटा प्रसंस्करण',
    priv_mdrTitle: 'MDR के अनुरूप संरेखित',
    priv_mdr1: 'कमजोर व्यक्तियों के लिए अतिरिक्त सुरक्षा',
    priv_mdr2: 'नैदानिक सुरक्षा और प्रदर्शन',
    priv_mdr3: 'स्क्रीनिंग और निदान का स्पष्ट अंतर',
    priv_mdr4: 'स्वास्थ्य डेटा के लिए नैतिक प्रबंधन',
    priv_retentionTitle: 'डेटा प्रतिधारण नीति',
    priv_12months: '12 महीने',
    priv_12monthsDesc: 'आई-ट्रैकिंग निर्देशांक और कीस्ट्रोक',
    priv_24months: '24 महीने',
    priv_24monthsDesc: 'विश्लेषण मेटाडेटा',
    priv_parentsControl: 'माता-पिता का नियंत्रण',
    priv_deleteAnytime: 'कभी भी हटाएं',

    mat_headline1: 'मानवीय सहानुभूति।',
    mat_headline2: 'कृत्रिम परिशुद्धता',
    mat_subheadline: 'जीवंत अनुभव और अत्याधुनिक AI को मिलाकर डिस्लेक्सिया स्क्रीनिंग को',
    mat_subheadlineHighlight: 'सबके लिए सुलभ बनाना',
    mat_whatTitle: 'हम क्या करते हैं',
    mat_what1: 'हम डिस्लेक्सिक पढ़ने के पैटर्न में गहरी विशेषज्ञता को उन्नत AI तकनीक के साथ जोड़ते हैं। वर्षों के शोध के बाद, हमने इन अंतर्दृष्टियों को एक अनुकूली AI को सिखाया है।',
    mat_what2: 'हमारी AI बुद्धिमान, बहु-परतीय परीक्षण करती है — प्रत्येक प्रतिक्रिया हजारों वास्तविक पढ़ने के पैटर्न से तुलना की जाती है। यह वास्तविक समय में सीखती है और सही अनुवर्ती प्रश्न पूछती है।',
    mat_what3: 'परिवारों को वह स्पष्टता देने के लिए जो उन्हें विश्वास के साथ अगला कदम उठाने के लिए चाहिए।',
    mat_whyTitle: 'हम यह क्यों करते हैं',
    mat_why1: 'कल्पना करें कि आपका बच्चा उन्हीं पढ़ने की चुनौतियों का सामना कर रहा है जो आपने कभी की थीं — लेकिन अब आप जानते हैं कि इसका एक नाम है: डिस्लेक्सिया। आप उत्तर चाहते हैं, लेकिन पहला परीक्षण €750 से €1,800 का है — कई परिवारों के लिए पहुंच से बाहर।',
    mat_why2: 'वह वास्तविकता हमारे दिल को तोड़ती है। हर बच्चा यह समझने का हकदार है कि वह कैसे सीखता है। हर माता-पिता उत्तर के हकदार हैं।',
    mat_why3: 'इसीलिए हम यहां हैं — क्योंकि अपने मन को समझना कभी भी एक विशेषाधिकार नहीं होना चाहिए। यह एक मानवाधिकार है।',
    mat_bgTitle: 'हमारी पृष्ठभूमि',
    mat_bg1: 'हम स्वयं डिस्लेक्सिया के साथ जिए हैं और 20 से अधिक वर्षों तक सुलभ पठन में विशेषज्ञता प्राप्त की है। इस जीवंत अनुभव को AI के साथ जोड़कर हमने एक सरल, किफायती और जीवन बदलने वाला डिस्लेक्सिया जांच उपकरण बनाया है।',
    mat_bg2: 'हमारी AI केवल पढ़ने की गति नहीं मापती या गलतियां नहीं गिनती — यह प्रत्येक आंख की हलचल, विराम और सुधार के पीछे का "कैसे" समझती है।',
    mat_techTitle: 'हमारी तकनीक',
    mat_tech1: 'इन सूक्ष्म अंतरों को बढ़ाकर, हमारी प्रणाली असाधारण परिशुद्धता के साथ डिस्लेक्सिया और अन्य पढ़ने की चुनौतियों के बीच अंतर करना सीखती है। हम deep clustering का उपयोग करते हैं — unsupervised learning का एक उन्नत रूप।',
    mat_tech2: 'यह बहु-परतीय, क्रॉस-संदर्भ दृष्टिकोण किसी भी पिछली विधि से अधिक निश्चितता लाता है — पहले से कहीं अधिक गहराई तक।',
    mat_eyeTitle: 'नेत्रगोलक ट्रैकिंग',
    mat_eyeText: 'हम दृष्टि स्थिरता, स्थिरीकरण अवधि और सैकेडिक गति को मापते हैं ताकि पता चल सके कि पढ़ने के दौरान दृश्य फोकस कैसे बदलता है।',
    mat_kbdTitle: 'कीबोर्ड डायनेमिक्स',
    mat_kbdText: 'कीस्ट्रोक लय, संकोच और सुधार गति अनुक्रमण और ध्वन्यात्मक चुनौतियों को उजागर करती है जो डिस्लेक्सिक प्रोफाइल के लिए विशिष्ट हैं।',
    mat_ferTitle: 'चेहरे की भावना पहचान (FER)',
    mat_ferText: 'सूक्ष्म भाव निराशा, संलग्नता या राहत प्रकट करते हैं — जिससे हमारी AI पढ़ने के प्रयास के पीछे की भावनात्मक परत को महसूस कर पाती है।',

    footer_about: 'हमारे बारे में',
    footer_blog: 'प्रकाशन',
    footer_contact: 'संपर्क',
    footer_faq: 'FAQ',
    footer_privacy: 'गोपनीयता',
    footer_terms: 'सेवा की शर्तें',
    footer_tagline: 'रियल-टाइम आईरिस ट्रैकिंग, कीबोर्ड डायनेमिक्स और चेहरे की अभिव्यक्ति विश्लेषण के साथ AI-संचालित डिस्लेक्सिया जांच — 8 भाषाओं में उपलब्ध, पूरी तरह ब्राउज़र में।',
    footer_productHeading: 'उत्पाद',
    footer_legalHeading: 'कानूनी',
    footer_mission: 'हर भाषा में, सभी के लिए डिस्लेक्सिया जांच को सुलभ बनाने के लिए निर्मित।',
    footer_copyright: 'सर्वाधिकार सुरक्षित',
    footer_madeWith: 'डिस्लेक्सिया जागरूकता के उद्देश्य से बनाया गया',
    footer_allSystems: 'सभी सिस्टम चालू',

    fp_assessmentBadge: 'अंतिम चरण',
    fp_feedbackTitle: 'एक अंतिम टिप्पणी साझा करें',
    fp_feedbackDesc: 'वैकल्पिक प्रतिक्रिया हमें मूल्यांकन अनुभव सुधारने में मदद करती है।',
    fp_shareThoughts: 'अपने विचार साझा करें',
    fp_optional: 'वैकल्पिक',
    fp_words: 'शब्द',
    fp_corrections: 'सुधार',
    fp_speed: 'गति',
    fp_feedbackPlaceholder: 'क्या कुछ कठिन, अस्पष्ट या सुधार योग्य था?',
    fp_observationNotesTitle: 'अवलोकन टिप्पणियाँ (वैकल्पिक)',
    fp_observationNotesDesc: 'परीक्षण के दौरान मौजूद माता-पिता या पर्यवेक्षक के लिए: कुछ भी जो आपने देखा हो जो स्क्रीन नहीं देख सकती — ध्यान भटकना, थकान, रोना, शोर, या परिणामों के साथ दर्ज करने योग्य कोई अन्य बात।',
    fp_observationNotesPlaceholder: 'जैसे "शब्द लेखन परीक्षण के दौरान थका हुआ लग रहा था" या "कहानी 1 के दौरान भाई-बहन से ध्यान भटक गया"',
    fp_generatingReport: 'आपकी रिपोर्ट तैयार की जा रही है…',
    fp_submitBtn: 'समाप्त करें और रिपोर्ट देखें',
    fp_skipHint: 'फीडबैक वैकल्पिक है। तैयार हों तो आगे बढ़ें।',
    fp_youNailedIt: 'मूल्यांकन पूरा हुआ',
    fp_reportGenerated: 'आपकी रिपोर्ट डैशबोर्ड में तैयार है।',
    fp_copySentTo: 'एक्सेस विवरण भेजा गया',
    fp_welcomeBack: 'रिपोर्ट सहेजी गई',
    fp_newReportAdded: 'आपके डैशबोर्ड परिणामों में जोड़ दी गई।',
    fp_reportReady: 'आपकी रिपोर्ट तैयार है',
    fp_reportSubtitle: 'पूर्ण विश्लेषण, नेत्र-ट्रैकिंग प्लेबैक और डिस्लेक्सिया संकेतक',
    fp_openingReport: 'आपकी रिपोर्ट खुल रही है…',
    fp_viewMyReport: 'मेरी रिपोर्ट देखें',
    fp_signInLater: 'या बाद में यहाँ साइन इन करें',
    fp_saveForAccess: 'भविष्य की पहुंच के लिए सहेजें',
    fp_emailLabel: 'ईमेल',
    fp_passwordLabel: 'पासवर्ड',
    fp_copied: 'कॉपी हो गया',
    fp_copy: 'कॉपी करें',
    fp_pwUpdated: 'पासवर्ड सफलतापूर्वक अपडेट किया गया',
    fp_setCustomPw: 'कस्टम पासवर्ड सेट करें',
    fp_newPwPlaceholder: 'नया पासवर्ड (न्यूनतम 4 अक्षर)',
    fp_save: 'सहेजें',
    fp_cancel: 'रद्द करें',
    fp_signInLink: 'डैशबोर्ड खोलें →',
    fp2_saving: 'आपके परिणाम सहेजे जा रहे हैं…',
    fp2_savingSub: 'इसमें कुछ सेकंड लगते हैं। कृपया यह पेज खुला रखें।',
    fp2_allDone: 'हो गया',
    fp2_reportReadySent: 'रिपोर्ट तैयार है। हमने लॉगिन विवरण भेजे हैं:',
    fp2_reportReadyReturning: 'रिपोर्ट तैयार है और आपके डैशबोर्ड में जोड़ दी गई है।',
    fp2_passwordLine: 'आपका पासवर्ड (ईमेल में भी):',
    fp2_openReport: 'रिपोर्ट खोलें',
    fp2_saveFailed: 'आपके परिणाम अभी सहेजे नहीं जा सके।',
    fp2_saveFailedSub: 'इंटरनेट कनेक्शन जाँचें और फिर से कोशिश करें। कृपया यह पेज खुला रखें।',
    fp2_tryAgain: 'फिर से कोशिश करें',
    fp2_sessionTitle: 'क्या टेस्ट के बारे में कुछ है जो हमें जानना चाहिए?',
    fp2_sessionOptional: 'वैकल्पिक · परिणाम नहीं बदलता',
    fp2_cTired: 'थका हुआ या ध्यान भटका',
    fp2_cCameraMic: 'कैमरा या माइक्रोफ़ोन की समस्या',
    fp2_cNoisy: 'शोर या रुकावटें',
    fp2_cLanguage: 'पहली भाषा नहीं',
    fp2_cHelped: 'किसी ने उत्तर देने में मदद की',
    fp2_cFroze: 'पेज अटक गया या दोबारा लोड करना पड़ा',
    fp2_saveNotes: 'नोट्स सहेजें',
    fp2_notesSaved: 'नोट्स सहेजे गए',
    fp2_notesFailed: 'नोट्स सहेजे नहीं जा सके। कृपया फिर से कोशिश करें।',
    fp_parentNote: '👨‍👩‍👧 अभिभावक के लिए एक नोट',
    fp_parentNoteDesc: 'मूल्यांकन पूरा हो गया है। कृपया बताएं कि आपके बच्चे ने आज के कार्यों को कैसे किया (वैकल्पिक)।',
    fp_screeningResult: 'स्क्रीनिंग परिणाम',
    fp_riskTypical: 'सामान्य — कोई महत्वपूर्ण संकेतक नहीं',
    fp_riskBorderline: 'सीमावर्ती — कुछ संकेतक मौजूद हैं',
    fp_riskHighRisk: 'उच्च जोखिम — कई संकेतक पाए गए',
    fp_riskVeryHighRisk: 'बहुत उच्च जोखिम — सभी क्षेत्रों में मजबूत संकेतक',
    fp_confidence: 'विश्वसनीयता',
    fp_keyFindings: 'मुख्य निष्कर्ष',
    fp_disclaimer: 'यह केवल एक स्क्रीनिंग टूल है — नैदानिक निदान नहीं। पूर्ण मूल्यांकन के लिए किसी पंजीकृत शैक्षिक मनोवैज्ञानिक से परामर्श लें।',
    fp_notAssessed: 'मूल्यांकन नहीं किया गया',
    fp_percentile: 'वां प्रतिशतक',
    fp_domainTypical: '✓ सामान्य',
    fp_domainBorderline: '⚠ सीमावर्ती',
    fp_domainHighRisk: '✗ उच्च जोखिम',
    fp_aiReportTitle: 'AI व्यक्तिगत रिपोर्ट',
    fp_aiGenerating: 'DysTest AI आपकी व्यक्तिगत रिपोर्ट तैयार कर रहा है…',
    fp_aiGenerated: 'DysTest AI द्वारा तैयार · नैदानिक निदान नहीं',
    fp_aiAnalysing: 'मूल्यांकन डेटा का विश्लेषण हो रहा है…',
    fp_strengths: 'ताकत',
    fp_areasToSupport: 'सहायता के क्षेत्र',
    fp_noDifficulties: 'कोई महत्वपूर्ण कठिनाई नहीं पाई गई।',
    fp_eyeTracking: 'नेत्र ट्रैकिंग:',
    fp_recommendations: 'सिफारिशें',
    fp_nextStep: 'अगला कदम:',
    pp_title: 'गोपनीयता नीति',
    pp_bannerTitle: 'आपकी गोपनीयता पवित्र है',
    pp_bannerDesc: 'हम मानते हैं कि आपका व्यक्तिगत डेटा आपका है, हमारा बेचने के लिए नहीं। हम केवल वही संग्रहीत करते हैं जो सटीक डिस्लेक्सिया स्क्रीनिंग के लिए आवश्यक है, और इसे उद्योग-अग्रणी सुरक्षा से सुरक्षित करते हैं। आपके पास हमेशा अपनी जानकारी पर पूर्ण नियंत्रण है।',
    pp_contactTitle: 'आपकी गोपनीयता के बारे में प्रश्न?',
    pp_contactDesc: 'हम पारदर्शिता के प्रति प्रतिबद्ध हैं। यदि आपके पास इस बारे में कोई प्रश्न है कि हम आपका डेटा कैसे संभालते हैं, तो हम यहाँ मदद करने के लिए हैं।',
    pp_privacyInquiries: 'गोपनीयता संबंधी पूछताछ',
    pp_generalSupport: 'सामान्य सहायता',
    pp_acknowledgment: 'DysTest सेवा का उपयोग करके, आप स्वीकार करते हैं कि आपने इस गोपनीयता नीति को पढ़ा और समझा है।',
    tos_title: 'सेवा की शर्तें',
    tos_missionTitle: 'हमारा मिशन',
    tos_missionDesc: 'अपने स्वयं के मन को समझना कोई विलासिता नहीं होनी चाहिए — यह एक मानव अधिकार है। हमारा मिशन हर उस परिवार के लिए डिस्लेक्सिया स्क्रीनिंग को सुलभ, किफायती और सटीक बनाना है।',
    tos_contactTitle: 'इन शर्तों के बारे में प्रश्न?',
    tos_contactDesc: 'हम यहाँ मदद करने के लिए हैं। यदि हमारी सेवा की शर्तों के बारे में कोई प्रश्न है, तो कृपया संपर्क करें।',
    tos_acknowledgment: 'DysTest सेवा का उपयोग करके, आप स्वीकार करते हैं कि आपने इन सेवा की शर्तों को पढ़ा, समझा है और इनसे बाध्य होने के लिए सहमत हैं।',
    shared_quickNav: 'त्वरित नेविगेशन',
    shared_backHome: '← होम पर वापस',
    shared_effectiveDate: 'प्रभावी तिथि: 30 अक्टूबर 2025',
    shared_lastUpdated: 'अंतिम अपडेट: 30 अक्टूबर 2025',
    shared_footerTagline: 'डिस्लेक्सिया परीक्षण को सटीक, सुलभ और किफायती बनाना।',
    shared_website: 'वेबसाइट',
    shared_email: 'ईमेल',
    blog_knowledgeBadge: 'DysTest ज्ञान केंद्र',
    blog_title: 'DysTest ब्लॉग',
    blog_subtitle: 'डिस्लेक्सिया, सीखने की कठिनाइयों और AI कैसे प्रारंभिक पहचान और सहायता में क्रांति ला रहा है, इस पर विशेषज्ञ अंतर्दृष्टि',
    blog_searchPlaceholder: 'डिस्लेक्सिया, सीखने की कठिनाइयों, AI मूल्यांकन के बारे में लेख खोजें...',
    blog_catAll: 'सभी',
    blog_catUnderstanding: 'डिस्लेक्सिया को समझना',
    blog_catEarlyDetection: 'प्रारंभिक पहचान',
    blog_catTechnology: 'तकनीक',
    blog_catNews: 'समाचार',
    blog_featuredBadge: '⭐ विशेष',
    blog_featuredArticles: 'विशेष लेख',
    blog_allArticles: 'सभी लेख',
    blog_article: 'लेख',
    blog_articles: 'लेख',
    blog_readMore: 'और पढ़ें →',
    blog_found: 'मिला',
    blog_forQuery: 'के लिए',
    blog_noResults: 'कोई लेख नहीं मिला',
    blog_noResultsDesc: 'अपनी खोज या फ़िल्टर मानदंड समायोजित करने का प्रयास करें',
    blog_clearFilters: 'फ़िल्टर साफ़ करें और सभी लेख दिखाएं',
    blog_newsletterTitle: 'डिस्लेक्सिया अनुसंधान पर अपडेट रहें',
    blog_newsletterDesc: 'डिस्लेक्सिया अनुसंधान, AI तकनीक और सीखने की रणनीतियों पर नवीनतम जानकारी अपने इनबॉक्स में प्राप्त करें।',
    blog_newsletterBtn: 'अपडेट के लिए सदस्यता लें',
    blog_newsletterPrivacy: 'कोई स्पैम नहीं। किसी भी समय सदस्यता रद्द करें। हम आपकी गोपनीयता का सम्मान करते हैं।',
    blog_newsletterEmailPlaceholder: 'अपना ईमेल दर्ज करें',
    blog_newsletterSending: 'भेजा जा रहा है…',
    blog_newsletterCheckInbox: 'लगभग हो गया — अपना इनबॉक्स देखें और पुष्टि के लिए लिंक पर क्लिक करें।',
    blog_newsletterError: 'कुछ गलत हो गया। कृपया बाद में फिर से कोशिश करें।',
    nws_working: 'एक पल…',
    nws_confirmedTitle: 'आपकी सदस्यता हो गई',
    nws_confirmedBody: 'धन्यवाद! आपको नए ब्लॉग, तकनीकी पेपर और हमारा न्यूज़लेटर मिलेगा। हर ईमेल में सदस्यता छोड़ने का लिंक होता है।',
    nws_wasUnsubscribed: 'इस पते की सदस्यता छोड़ी जा चुकी है। अपडेट पाने के लिए ब्लॉग पर फिर से सदस्यता लें।',
    nws_unsubTitle: 'DysTest अपडेट की सदस्यता छोड़ें?',
    nws_unsubBody: 'आपको अब नए ब्लॉग, तकनीकी पेपर या न्यूज़लेटर नहीं मिलेंगे।',
    nws_unsubBtn: 'सदस्यता छोड़ें',
    nws_unsubDoneTitle: 'आपकी सदस्यता छोड़ दी गई',
    nws_unsubDoneBody: 'आपको अब कोई अपडेट नहीं मिलेगा। मन बदल गया? आप ब्लॉग पर फिर से सदस्यता ले सकते हैं।',
    nws_invalidTitle: 'यह लिंक मान्य नहीं है',
    nws_invalidBody: 'लिंक पुराना या अधूरा हो सकता है। आप ब्लॉग पर फिर से सदस्यता ले सकते हैं।',
    nws_toBlog: 'ब्लॉग पर जाएँ',
    blog_backToArticles: 'लेखों पर वापस जाएं',
    blog_loadingArticle: 'लेख लोड हो रहा है...',
    blog_articleNotFound: 'लेख नहीं मिला',
    blog_ctaTitle: 'और जानने के लिए तैयार हैं?',
    blog_ctaDesc: 'जानें कि DysTest कैसे हमारे AI-संचालित मूल्यांकन से सीखने की कठिनाइयों की पहचान कर सकता है और हर बच्चे की क्षमता को उजागर कर सकता है।',
    blog_tryDystest: 'DysTest मूल्यांकन आज़माएं',
    blog_readMoreArticles: 'अधिक लेख पढ़ें',
    faq_badge: 'सवाल हैं? हमारे पास जवाब हैं',
    faq_title: 'अक्सर पूछे जाने वाले प्रश्न',
    faq_subtitle: 'हमारी',
    faq_subtitleHighlight: 'आई-ट्रैकिंग डिस्लेक्सिया स्क्रीनिंग',
    faq_searchPlaceholder: "प्रश्न खोजें... (जैसे, 'लागत', 'गोपनीयता', 'कितना समय')",
    faq_mostPopular: 'सबसे लोकप्रिय प्रश्न',
    faq_noResults: 'आपकी खोज से मेल खाने वाले कोई प्रश्न नहीं मिले।',
    faq_clearFilters: 'फ़िल्टर साफ़ करें',
    faq_stillHave: 'अभी भी प्रश्न हैं?',
    faq_supportDesc: 'हमारी सहायता टीम आपकी मदद के लिए यहाँ है। हम आमतौर पर 24 घंटों के भीतर जवाब देते हैं।',
    faq_contactSupport: 'सहायता से संपर्क करें',
    faq_startScreening: 'स्क्रीनिंग शुरू करें',
    faq_catAll: 'सभी',
    faq_related: 'संबंधित:',
    about_badge: 'हमारी कहानी',
    about_title: 'DysTest के बारे में',
    about_subtitle: 'हम मानते हैं कि हर बच्चा समझे जाने का हकदार है — केवल परखा जाने का नहीं।',
    about_backHome: '← होम पर वापस',
    about_ctaTitle: 'शुरू करने के लिए तैयार हैं?',
    about_ctaDesc: 'आज ही अपने बच्चे के लिए एक दयालु स्क्रीनिंग शुरू करें और जानें कैसे DysTest हर सीखने वाले की क्षमता को उजागर करती है।',
    about_startScreening: 'स्क्रीनिंग शुरू करें',
    about_startAssessment: 'शुरू करें',
    about_navWhy: 'DysTest क्यों अस्तित्व में है',
    about_navMissionValues: 'मिशन और मूल्य',
    about_navTechnology: 'तकनीक',
    about_navTeam: 'DysTest के पीछे के लोग',
    ran_audio_preLetter: 'अक्षर नामकरण। प्रत्येक पंक्ति के अक्षर जोर से पढ़ें, जितनी जल्दी हो सके।',
    ran_audio_preDigit: 'अब अंक। प्रत्येक पंक्ति की संख्याएं जोर से पढ़ें, जितनी जल्दी हो सके।',
    ran_audio_preColor: 'अब रंग। प्रत्येक वर्ग का रंग जोर से बोलें, जितनी जल्दी हो सके।',
    ran_audio_preObject: 'अब वस्तुएं। प्रत्येक चित्र का नाम जोर से बोलें, जितनी जल्दी हो सके।',
    ran_audio_runLetter: 'प्रत्येक अक्षर जोर से पढ़ें जितनी जल्दी हो सके।',
    ran_audio_runDigit: 'प्रत्येक संख्या जोर से पढ़ें जितनी जल्दी हो सके।',
    ran_audio_runColor: 'प्रत्येक वर्ग का रंग जोर से बोलें जितनी जल्दी हो सके।',
    ran_audio_runObject: 'प्रत्येक चित्र का नाम जोर से बोलें जितनी जल्दी हो सके।',
    ran_audio_practice: 'चलो अभ्यास करते हैं। हर अक्षर जोर से बोलें।',
    ran_intro_t1_heading: 'चलो कुछ अक्षर बोलें! 🔤',
    ran_intro_t1_desc1: 'आप स्क्रीन पर बड़े अक्षर देखेंगे।',
    ran_intro_t1_desc2: 'हर एक को जोर से जितनी जल्दी हो सके बोलें!',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'आप अक्षरों, अंकों, रंगों और वस्तुओं की पंक्तियां देखेंगे। हर पंक्ति जितनी जल्दी हो सके जोर से पढ़ें — बाएं से दाएं।',
    ran_intro_desc2: 'प्रत्येक पंक्ति पूरी होने के बाद परीक्षक अगली पंक्ति दबाएंगे। पहले हम एक छोटा अभ्यास करेंगे।',
    ran_intro_labLetters: 'अक्षर',
    ran_intro_labDigits: 'अंक',
    ran_intro_labColors: 'रंग',
    ran_intro_labObjects: 'वस्तुएं',
    ran_practice_t1_heading: 'क्या आप इन्हें बोल सकते हैं? 👀',
    ran_practice_heading: 'अभ्यास',
    ran_practice_t1_desc: 'हर अक्षर जोर से बोलें। बाईं ओर से शुरू करें!',
    ran_practice_desc: 'इस अक्षर पंक्ति को जोर से पढ़ें, बाएं से दाएं। जब आप पूरा कर लें तो परीक्षक अगली पंक्ति टैप करेंगे।',
    ran_practice_hint: 'बोलें: "a · o · s · p · k" — फिर नीचे बटन दबाएं।',
    ran_btn_try: 'चलो कोशिश करें! 🎉',
    ran_btn_practise: 'चलो अभ्यास करें',
    ran_btn_skip: 'छोड़ें',
    ran_btn_gotIt: 'समझ गया — अक्षर शुरू करें →',
    ran_btn_begin: 'शुरू करें — पंक्ति 1 पढ़ें →',
    ran_btn_nextRow: 'अगली पंक्ति',
    ran_btn_continue: 'आगे बढ़ें',
    ran_preLetter_title: 'अक्षर नामकरण  (RAN-L)',
    ran_preLetter_subtitle: '50 अक्षर · 10 की 5 पंक्तियां। हर पंक्ति जोर से जितनी जल्दी हो सके पढ़ें।',
    ran_preLetter_detail: 'परीक्षक हर पंक्ति के बाद अगली पंक्ति टैप करेंगे।',
    ran_preLetter_btn: 'ग्रिड दिखाएं →',
    ran_preDigit_title: 'अक्षर हो गए! अब अंक  (RAN-D)',
    ran_preDigit_subtitle: 'अब अंकों के साथ यही कार्य: 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 अंक · 10 की 5 पंक्तियां · वही नियम।',
    ran_preDigit_btn: 'अंक शुरू करें →',
    ran_preColor_title: 'अंक हो गए! अब रंग  (RAN-C)',
    ran_preColor_subtitle: 'हर वर्ग का रंग जोर से बोलें, जितनी जल्दी हो सके।',
    ran_preColor_detail: '50 रंगीन वर्ग · 10 की 5 पंक्तियां · वही नियम।',
    ran_preColor_btn: 'रंग शुरू करें →',
    ran_preObject_title: 'रंग हो गए! अब वस्तुएं  (RAN-O)',
    ran_preObject_subtitle: 'हर चित्र का नाम जोर से बोलें, जितनी जल्दी हो सके।',
    ran_preObject_detail: '50 वस्तुएं · 10 की 5 पंक्तियां · वही नियम।',
    ran_preObject_btn: 'वस्तुएं शुरू करें →',
    ran_done_t1_heading: 'शानदार काम! 🌟',
    ran_done_heading: 'सभी नामकरण कार्य पूरे!',
    ran_done_t1_desc: 'आपने सभी अक्षर बोले!',
    ran_done_desc: 'यहां परिणाम हैं:',
    ran_badge: 'तीव्र नामकरण परीक्षण',
    ran_intro_watchDemo: '👀 देखें यह कैसे काम करता है',
    ran_intro_t1_lead: 'हर अक्षर को देखें और जितनी जल्दी हो सके जोर से कहें — बाएं से दाएं!',
    ran_intro_step1: 'पंक्ति को देखें',
    ran_intro_step2: 'हर एक को जोर से कहें',
    ran_intro_step3: 'जितनी तेज़ी से हो सके जाएं!',
    ran_intro_demoLabel: 'हर आइटम को जोर से कहें, जितनी तेज़ी से हो सके!',
    ran_btn_start: 'शुरू करें 🚀',
    ran_btn_tapStart: 'पंक्ति 1 शुरू करने के लिए क्लिक करें',
    ran_btn_listening: 'सुन रहे हैं…',
    ran_btn_repeat: 'निर्देश दोहराएं',
    ran_processing: 'प्रक्रिया हो रही है…',
    ran_transcribing: 'Whisper से ऑडियो ट्रांसक्राइब हो रहा है…',
    ran_transcribingDesc: 'बोलने की सटीकता का विश्लेषण — इसमें कुछ सेकंड लगते हैं',
    ran_stat_totalTime: 'कुल समय',
    ran_stat_itemsPerSec: 'आइटम/सेकंड',
    ran_stat_avgItem: 'औसत आइटम',
    ran_stat_mistakes: 'गलतियाँ',
    ran_paceHint: 'हाइलाइट = वर्तमान पंक्ति  ·  मूल्यांकक गति नियंत्रित करता है',
    ran_running_letter: '🔤 RAN-L — अक्षर',
    ran_running_digit: '🔢 RAN-D — अंक',
    ran_running_color: '🎨 RAN-C — रंग',
    ran_running_object: '🦎 RAN-O — वस्तुएं',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'होम',
    nav_about: 'हमारे बारे में',
    nav_resources: 'संसाधन',
    nav_startAssessment: 'मूल्यांकन शुरू करें',
    nav_langMenuTitle: 'मूल्यांकन की भाषा',
    nav_langMenuHint: 'कहानियाँ और निर्देश इसी भाषा में होंगे',
    nav_techPapers: 'तकनीकी पत्र',
    nav_blog: 'ब्लॉग',
    nav_guides: 'गाइड',
    nav_faq: 'सामान्य प्रश्न',

        wwt_badge: 'शब्द लेखन परीक्षण',
    wwt_introTitle: 'शब्द को याद करें और टाइप करें',
    wwt_introDesc: 'एक शब्द 5 सेकंड के लिए दिखाई देता है — फिर यह अक्षर दर अक्षर मिट जाता है और आप इसे स्मृति से टाइप करते हैं',
    wwt_demoHint: 'शब्द गायब हो जाता है — आप इसे स्मृति से टाइप करते हैं',
    wwt_startWriting: 'लिखना शुरू करें!',
    wwt_rememberWord: 'इस शब्द को याद करें',
    wwt_watchCountdown: 'काउंटडाउन देखें — फिर याददाश्त से लिखें',
    wwt_typeWord: 'जो शब्द आपने देखा उसे लिखें',
    wwt_pressEnter: 'इसे टाइप करें और Enter या अगला दबाएं',
    wwt_nextWord: 'अगला शब्द',
    wwt_finish: 'समाप्त',
    wwt_done: 'शाबाश!',
    wwt_correct: 'शब्द सही',
    wwt_continue: 'जारी रखें',
    wwt_wordOf: 'शब्द {current} में से {total}',
    form_badgeText: 'चरण 1/8: रजिस्टर करें',
    form_heading: 'पंजीकरण करें और शुरू करें',
    form_privacyNote: 'आपका डेटा GDPR और MDR नियमों द्वारा सुरक्षित है। तीसरे पक्षों के साथ कोई व्यक्तिगत पहचान योग्य जानकारी साझा नहीं की जाती।',

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'माइक्रोफ़ोन जाँच',
    mic_sub_checking: 'माइक्रोफ़ोन जाँचा जा रहा है…',
    mic_sub_ready: 'माइक्रोफ़ोन तैयार है — रिकॉर्ड करने के लिए टेस्ट करें',
    mic_sub_recording: 'रिकॉर्डिंग हो रही है… अभी बोलें',
    mic_sub_retry: 'हम आपकी आवाज़ ठीक से नहीं सुन पाए — फिर से प्रयास करें',
    mic_sub_passed: 'माइक्रोफ़ोन बिल्कुल सही काम कर रहा है!',
    mic_sub_denied: 'माइक्रोफ़ोन की अनुमति अस्वीकृत',
    mic_pleaseSpeak: '🗣️ कृपया अभी बोलें…',
    mic_retryBody: 'हम आपको स्पष्ट रूप से नहीं सुन पाए। थोड़ा ज़ोर से बोलें और फिर से प्रयास करें।',
    mic_testBtn: 'माइक्रोफ़ोन टेस्ट करें',
    mic_tryAgain: 'फिर से प्रयास करें',
    mic_continueBtn: 'जारी रखें',
    mic_skipDenied: 'छोड़ें (माइक्रोफ़ोन नहीं है)',
    mic_skip: 'माइक जाँच छोड़ें',
    ud_myDashboard: 'मेरा डैशबोर्ड',
    ud_myAssessmentReports: 'मेरी मूल्यांकन रिपोर्ट',
    ud_noAssessmentsFound: 'कोई पूर्ण मूल्यांकन नहीं मिला।',
    ud_assessmentsFoundSingular: '1 पूर्ण मूल्यांकन मिला।',
    ud_assessmentsFoundPlural: '{n} पूर्ण मूल्यांकन मिले।',
    ud_loadError: 'आपके मूल्यांकन लोड नहीं हो सके। अपना कनेक्शन जाँचें और पृष्ठ ताज़ा करें।',
    ud_serviceUnavailable: 'सर्वर अस्थायी रूप से अनुपलब्ध है (503)। कृपया थोड़ा प्रतीक्षा करें और पृष्ठ ताज़ा करें।',
    ud_progressOverTime: 'समय के साथ प्रगति',
    ud_longitudinalSubtitle: '{n} मूल्यांकन · संयुक्त z-स्कोर प्रवृत्ति',
    ud_typical: 'सामान्य (z ≥ −0.5)',
    ud_borderline: 'सीमारेखा (z < −0.5)',
    ud_highRisk: 'उच्च जोखिम (z < −1.0)',
    ud_veryHighRisk: 'बहुत उच्च जोखिम (z < −1.5)',
    ud_noAssessmentsFor: 'के लिए कोई मूल्यांकन नहीं मिला',
    ud_completeAssessment: 'यहाँ अपने परिणाम देखने के लिए एक मूल्यांकन पूरा करें।',
    ud_startAssessment: 'मूल्यांकन शुरू करें',
    ud_assessmentReport: 'मूल्यांकन रिपोर्ट',
    ud_completed: 'पूर्ण',
    ud_accuracy: 'सटीकता',
    ud_blinks: 'पलकें',
    ud_questions: 'प्रश्न',
    ud_rawData: 'कच्चा डेटा (JSON)',
    ud_tabEyeTracking: 'नेत्र ट्रैकिंग',
    ud_tabRan: 'RAN विश्लेषण',
    ud_tabStory: 'कहानी विश्लेषण',
    ud_gazePlaybackTitle: 'नेत्र ट्रैकिंग प्लेबैक — 3 मोड: ग्रिड · हीटमैप · पथ',
    ud_noGazeData: 'इस मूल्यांकन के लिए कोई नेत्र ट्रैकिंग डेटा उपलब्ध नहीं है।',
    ud_gazeDataNote: 'नेत्र ट्रैकिंग डेटा लाइव मूल्यांकन सत्र के दौरान कैप्चर किया जाता है और रिपोर्ट के साथ संग्रहीत किया जाता है।',
    ud_ranTitle: 'RAN — त्वरित स्वचालित नामकरण परिणाम',
    ud_totalTime: 'कुल समय',
    ud_rawSpeed: 'कच्ची गति',
    ud_correctedSpeed: 'सुधारित गति',
    ud_errors: 'त्रुटियाँ',
    ud_rowTimings: 'पंक्ति समय',
    ud_transcriptComparison: 'ट्रांसक्रिप्ट तुलना',
    ud_row: 'पंक्ति',
    ud_audioNote: 'पूर्ण ZIP रिपोर्ट में ऑडियो प्लेबैक उपलब्ध है · ऊपर पूरी रिपोर्ट (ZIP) डाउनलोड करें',
    ud_storyTitle: 'कहानी पठन विश्लेषण',
    ud_story1Label: 'कहानी 1 — पठन चरण',
    ud_story2Label: 'कहानी 2 — पठन चरण',
    ud_readingTime: 'पठन समय',
    ud_fixations: 'स्थिरता',
    ud_regressions: 'प्रतिगमन',
    ud_avgFixation: 'औसत स्थिरता',
    ud_saccades: 'सैकेड',
    ud_blinkRate: 'पलक दर',
    ud_gazeStoryTitle: 'नेत्र ट्रैकिंग — कहानी पृष्ठ',
    ud_noStoryGaze: 'इस मूल्यांकन के लिए कहानी नेत्र ट्रैकिंग डेटा उपलब्ध नहीं है।',
    ud_footer: 'आपका डेटा केवल इस डिवाइस पर सुरक्षित रूप से संग्रहीत है।',
    ud_changePassword: 'पासवर्ड बदलें',
    ud_changePasswordDesc: 'अपने खाते के लिए नया पासवर्ड सेट करें। आप इसे अगली बार साइन इन करते समय उपयोग करेंगे।',
    ud_passwordUpdated: 'पासवर्ड सफलतापूर्वक अपडेट किया गया',
    ud_newPasswordPlaceholder: 'नया पासवर्ड (न्यूनतम 4 अक्षर)',
    ud_saving: 'सहेजा जा रहा है…',
    ud_saveNewPassword: 'नया पासवर्ड सहेजें',
    ud_passwordTooShort: 'पासवर्ड कम से कम 4 अक्षर का होना चाहिए।',
    ud_passwordUpdateFailed: 'आपका पासवर्ड अपडेट नहीं हो सका। कृपया पुनः प्रयास करें।',
    ud_accuracySuffix: 'सटीकता',
    acp_tabCamera: 'कैमरा',
    acp_tabKeyboard: 'कीबोर्ड',
    acp_tabMicrophone: 'माइक्रोफ़ोन',
    acp_checkingCameraQuality: 'कैमरा गुणवत्ता जाँच रहे हैं — इसमें कुछ सेकंड लगेंगे',
    acp_allChecksPassed: 'सभी जाँचें सफल!',
    acp_allSystemsReady: 'कैमरा, कीबोर्ड और माइक्रोफ़ोन तैयार हैं।',
    mini_step: 'चरण',
    scp_setupComplete: '🎉 सेटअप पूर्ण!',
    scp_allSetSubtitle: 'आप डिस्लेक्सिया मूल्यांकन के लिए तैयार हैं',
    scp_setupQualityScore: 'सेटअप गुणवत्ता स्कोर',
    scp_excellentSetup: 'सटीक मूल्यांकन के लिए उत्कृष्ट सेटअप गुणवत्ता',
    scp_completedSteps: '✅ पूर्ण चरण',
    scp_cameraReadiness: 'कैमरा तैयारी',
    scp_cameraStabilityPassed: '10-सेकंड स्थिरता जाँच सफल',
    scp_keyboardCapture: 'कीबोर्ड कैप्चर',
    scp_keystrokeData: 'नैदानिक कीस्ट्रोक डेटा कैप्चर किया गया',
    scp_eyeCalibration: 'नेत्र कैलिब्रेशन',
    scp_calibrationCompleted: 'कैलिब्रेशन पूर्ण ({pct}% सटीकता)',
    scp_whatsNext: 'आगे क्या?',
    scp_whatsNextBody: 'आप पठन मूल्यांकन शुरू करेंगे जहाँ हम डिस्लेक्सिया की व्यापक जाँच के लिए आपकी आँखों की गतिविधि, चेहरे के भाव और पठन पैटर्न का विश्लेषण करेंगे।',
    scp_startAssessment: 'डिस्लेक्सिया मूल्यांकन शुरू करें',
    scp_startingAssessment: 'मूल्यांकन शुरू हो रहा है...',
    scp_estimatedTime: 'अनुमानित समय: 10-15 मिनट',

    // UserDashboard रिपोर्ट ग्रिड
    ud_view: 'देखें',
    ud_report_userInfo: 'उपयोगकर्ता जानकारी',
    ud_report_envSetup: 'पर्यावरण सेटअप',
    ud_report_wordIcon: 'शब्द-चिह्न मिलान',
    ud_report_ran: 'RAN विश्लेषण',
    ud_report_story: 'कहानी विश्लेषण',
    ud_report_wordWriting: 'शब्द लेखन',
    ud_report_feedback: 'प्रतिक्रिया',
    ud_report_summary: 'सारांश',
    ul_platform: 'डिस्लेक्सिया मूल्यांकन प्लेटफ़ॉर्म',
    ul_invalidCredentials: 'ईमेल या पासवर्ड अमान्य है। अपने मूल्यांकन के अंत में दिखाए गए लॉगिन विवरण जाँचें।',
    ul_loginFailed: 'लॉगिन विफल हुआ। कृपया फिर प्रयास करें।',
    ul_resetFailed: 'कुछ गलत हो गया। कृपया फिर प्रयास करें।',
    ul_backToSignIn: 'साइन इन पर वापस जाएँ',
    ul_checkEmail: 'अपना ईमेल जाँचें',
    ul_smtpDevNotice: 'SMTP कॉन्फ़िगर नहीं है (dev). अस्थायी पासवर्ड:',
    ul_resetSent: 'यदि {email} पंजीकृत है, तो नया पासवर्ड भेजा जा रहा है।',
    ul_signIn: 'साइन इन',
    ul_resetPassword: 'पासवर्ड रीसेट करें',
    ul_resetPasswordDesc: 'अपना ईमेल दर्ज करें और हम आपको नया पासवर्ड भेजेंगे।',
    ul_emailAddress: 'ईमेल पता',
    ul_emailPlaceholder: 'आपका@email.com',
    ul_sending: 'भेजा जा रहा है…',
    ul_sendNewPassword: 'नया पासवर्ड भेजें',
    ul_welcomeBack: 'वापस स्वागत है',
    ul_signInSubtitle: 'अपने मूल्यांकन परिणाम देखने के लिए साइन इन करें',
    ul_password: 'पासवर्ड',
    ul_passwordPlaceholder: 'आपका पासवर्ड',
    ul_hidePassword: 'पासवर्ड छिपाएँ',
    ul_showPassword: 'पासवर्ड दिखाएँ',
    ul_forgotPassword: 'पासवर्ड भूल गए?',
    ul_signingIn: 'साइन इन हो रहा है…',
    ul_signInDashboard: 'अपने डैशबोर्ड में साइन इन करें',
    ul_firstTime: 'पहली बार आए हैं? आपका खाता मूल्यांकन के बाद अपने आप बनाया गया था। लॉगिन विवरण के लिए अपना ईमेल जाँचें।',
    ul_footer: 'GDPR और MDR अनुरूप · कोई वीडियो संग्रहीत नहीं',

    mg_title: 'विज्ञान के लिए थोड़ा रुकिए!',
    mg_body: 'DysTest आपकी आँखों की हरकत (पिक्सेल तक सटीक!), आपकी टाइपिंग की गति और आपकी आवाज़ को मिलीसेकंड तक जाँचता है।\n\nबहुत स्मार्ट तकनीक है, लेकिन इसकी एक कमज़ोरी है: जब स्क्रीन आपके हाथ में हिलती रहती है, तब यह काम नहीं करती। इसलिए भरोसेमंद नतीजे के लिए लैपटॉप या डेस्कटॉप खोलिए!',
    mg_howTo: 'शुरू कैसे करें',
    mg_step1: 'लैपटॉप या डेस्कटॉप पर dystest.com खोलें',
    mg_step2: 'सुनिश्चित करें कि आपका वेबकैम और कीबोर्ड जुड़े हुए हैं',
    mg_step3: 'सर्वोत्तम परिणामों के लिए Chrome या Firefox का उपयोग करें',
    mg_returnHome: 'होमपेज पर लौटें',
    mg_shareLink: 'मुझे लिंक भेजें',
    mg_copyLink: 'लिंक कॉपी करें',
    mg_linkCopied: 'लिंक कॉपी हो गया',
    mg_alreadyDone: 'पहले ही टेस्ट कर चुके हैं?',
    mg_loginLink: 'रिपोर्ट देखने के लिए लॉग इन करें',
    mg_emailLabel: 'आपका ईमेल पता',
    mg_emailPlaceholder: 'naam@example.com',
    mg_emailSend: 'भेजें',
    mg_emailSent: 'भेज दिया! टेस्ट शुरू करने के लिए ईमेल को अपने लैपटॉप या कंप्यूटर पर खोलें।',
    mg_emailError: 'ईमेल नहीं भेजा जा सका। पता जाँचें और फिर से कोशिश करें।',
};

export default hi;
